import { useEffect, useRef, useState } from 'react'
import { registerCourseConsentHandler } from '@/lib/course-consent'
import type { CourseRequirements } from '@/lib/credits-api'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export function CourseConsentDialog() {
  const [requirements, setRequirements] = useState<CourseRequirements | null>(null)
  const [accepted, setAccepted] = useState(false)
  const resolveRef = useRef<((accepted: boolean) => void) | null>(null)
  useEffect(() => {
    const unregister = registerCourseConsentHandler((next) =>
      new Promise<boolean>((resolve) => {
        resolveRef.current?.(false)
        resolveRef.current = resolve
        setAccepted(false)
        setRequirements(next)
      })
    )
    return () => {
      unregister()
      resolveRef.current?.(false)
    }
  }, [])
  function finish(value: boolean) {
    resolveRef.current?.(value)
    resolveRef.current = null
    setRequirements(null)
  }
  return (
    <Dialog
      open={requirements !== null}
      onOpenChange={(open) => {
        if (!open) finish(false)
      }}
    >
      <DialogContent className='max-h-[90dvh] overflow-y-auto'>
        <DialogHeader>
          <DialogTitle>Kurs-AGB: {requirements?.course_name}</DialogTitle>
          <DialogDescription>
            Bitte bestätige die aktuelle Fassung vor deiner Teilnahme.
          </DialogDescription>
        </DialogHeader>
        <div className='whitespace-pre-wrap rounded-md border p-4 text-sm'>
          {requirements?.terms_body}
        </div>
        <label className='flex items-start gap-3 text-sm'>
          <Checkbox
            checked={accepted}
            onCheckedChange={(value) => setAccepted(value === true)}
          />Ich akzeptiere diese Kurs-AGB.
        </label>
        <DialogFooter>
          <Button variant='outline' onClick={() => finish(false)}>Abbrechen</Button>
          <Button disabled={!accepted} onClick={() => finish(true)}>
            Akzeptieren und fortfahren
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
